// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bcb_a bik_i bik_j","ColorVariants__color":"bcb_b bik_rp","ColorVariants__more":"bcb_c bik_vv"};